import { h, Host } from "@stencil/core";
export class FlipCard {
    constructor() {
        this.flipped = false;
    }
    flip() {
        this.flipped = !this.flipped;
    }
    render() {
        return (h(Host, { key: 'd796c51c346418cda41ca07556ad3ed048ba5f43', class: {
                'flip-card': true,
                'flip-card-flipped': this.flipped
            } }, h("div", { key: '9687b33d4ee102e5d828ea774f409a41f61ef1ef', class: "flip-card-front", onClick: () => this.flip() }, h("slot", { key: 'a99097e80402b1d033509a74c120ebedb9bfeec3', name: "front" })), h("div", { key: '4095d9fae439954cd33c6d1cb430d799570cd3ff', class: "flip-card-back" }, h("div", { key: '30b75807b54e34056f878edbc1d3129b49331b31', class: "description" }, h("a", { key: '5f83da8b3cebf33da1e8fbfd000655fd2a8742ea', class: "modal-close", "aria-label": "flip", role: 'button', onClick: () => this.flip() }, h("svg", { key: 'c1d9462acb2f4453cd0c41ce98e8ff11b71794b4', width: 24, height: 24 }, h("use", { key: '5f4ff1768473b183a4693fe5aaab81be74696f42', href: "#fa-close" }))), h("slot", { key: 'bb18e7a6f281a46e06c83cce3174d682fd64baab', name: "back" })))));
    }
    static get is() { return "uvex-flip-card"; }
    static get states() {
        return {
            "flipped": {}
        };
    }
}
//# sourceMappingURL=flip-card.js.map
